import { parseCartOfferItem } from 'lib/order/parseCartItem'
import { incrementUuidV4 } from 'lib/uuidV4'
import {
  RESERVATION_TYPE_BOOK_LATER,
  RESERVATION_TYPE_BOOK_LATER_DATE_SELECTION,
  RESERVATION_TYPE_INSTANT_BOOKING,
} from 'constants/reservation'
import { ITEM_STATUS_AWAITING_DATES } from 'constants/cart'
import { getSingleItemBaseTotalWithFeesWithoutExtras } from 'selectors/cart/cartAmountSelectors'
import { OFFER_TYPE_TOUR } from 'constants/offer'
import config from 'constants/config'

interface SvcCartV1HotelItem {
  cart_item_id: string;
  offer_id: string;
  package_id: string;
  room_rate_id?: string;
  transaction_key: string;
  offer_booking_type: string;
  offer_type: string;
  offer_slug: string;
  reservation_type: string;
  value: number;
  price: number;
  surcharge: number;
  extra_guest_surcharge: number;
  property_fees: number;
  total: number;
  localizedPrices: number;
  number_of_nights: number;
  check_in?: string;
  check_out?: string;
  number_of_adults?: number;
  number_of_children?: number;
  number_of_infants?: number;
  children_ages?: number[];
}

export function getHotelItems(state: App.State) {
  const cart = state.cart

  if (cart.items.length > 0) {
    const isBNBLDateSelection =
      cart.order &&
      cart.order.items &&
      cart.order.items.length > 0 &&
      cart.order.items[0].reservationType === RESERVATION_TYPE_BOOK_LATER &&
      cart.order.items[0].status === ITEM_STATUS_AWAITING_DATES

    const accommodation = isBNBLDateSelection ?
      Object.assign({}, cart.accommodation, {
        reservationType: RESERVATION_TYPE_BOOK_LATER_DATE_SELECTION,
      }) :
      cart.accommodation

    if (isTourV1NewCheckout(accommodation)) {
      // Tour V1 new checkout is currently using the old booking page for
      // selecting number of travellers and dates. In this case we don't want
      // to send the cart items to the cart service. Otherwise, they will always
      // be "abandoned", as the cart ID will be different from the new checkout.
      return []
    }

    return cart.items.map((item, index) => parseCartOfferItem(
      item,
      accommodation.occupancies[index],
      accommodation,
      undefined,
      undefined,
      undefined,
      getSingleItemBaseTotalWithFeesWithoutExtras(state, item),
    ))
  } else {
    return []
  }
}

function isTourV1NewCheckout(accommodation?: App.CartAccommodation): boolean {
  return (
    accommodation?.offer.type === OFFER_TYPE_TOUR &&
    accommodation.reservationType === RESERVATION_TYPE_INSTANT_BOOKING &&
    config.UNIVERSAL_CHECKOUT_LE_TOUR_ENABLED
  )
}

export function getBedbankItems(
  state: App.State,
): SvcCartV1HotelItem[] {
  let nextTransactionKey = state.cart.transactionKey
  const bedbank = state.cart.bedbank

  if (bedbank && bedbank.rooms.length > 0) {
    return bedbank.rooms.map((room) => {
      nextTransactionKey = incrementUuidV4(nextTransactionKey)
      return {
        cart_item_id: nextTransactionKey,
        offer_id: bedbank.offer.id,
        package_id: bedbank.package.roomId,
        room_rate_id: bedbank.rate.id,
        transaction_key: bedbank.transactionKey,
        offer_booking_type: 'reservation',
        offer_type: bedbank.offer.type,
        offer_slug: bedbank.offer.slug,
        reservation_type: RESERVATION_TYPE_INSTANT_BOOKING,
        value: bedbank.rate.value,
        price: bedbank.rate.totals.inclusive,
        surcharge: 0,
        extra_guest_surcharge: 0,
        property_fees: bedbank.rate.totals.propertyFees || 0,
        total: bedbank.price,
        localizedPrices: 0,
        number_of_nights: bedbank.rate.nights,
        check_in: bedbank.checkIn,
        check_out: bedbank.checkOut,
        number_of_adults: room.occupancy.adults,
        number_of_children: room.occupancy.children || 0,
        number_of_infants: room.occupancy.infants || 0,
        children_ages: room.occupancy.childrenAge || [],
      }
    })
  } else {
    return []
  }
}
